import React from 'react';

const Success = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      opacity="0.08"
      cx="8.16667"
      cy="8"
      rx="8.16667"
      ry="8"
      fill="#00D28F"
    />
    <path
      d="M4.76392 7.83331L7.9285 10.3333L11.5695 5.33331"
      stroke="#00D28F"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default Success;
